/**
 * VUKZ Due Diligence Checklist
 * Status tracking for investor readiness
 */

export const DUE_DILIGENCE_SECTIONS = [
  {
    id: 'corporate',
    title: 'Societário & Legal',
    items: [
      { id: 'company-reg', label: 'CNPJ ativo e regular', status: 'done' },
      { id: 'contract-social', label: 'Contrato Social atualizado', status: 'done' },
      { id: 'ltda-sa', label: 'Conversão LTDA → S/A', status: 'pending', note: 'Necessário pré-Seed' },
      { id: 'shareholder-agreement', label: 'Acordo de Acionistas', status: 'pending' },
      { id: 'ip-assignment', label: 'Cessão de PI para a empresa', status: 'partial', note: 'Código em repo da empresa, falta contrato formal' },
      { id: 'employment', label: 'Contratos de trabalho/PJ', status: 'done', note: 'Founder + eventuais freelancers' },
      { id: 'no-litigation', label: 'Certidões negativas (trabalhista, fiscal)', status: 'done' },
    ],
  },
  {
    id: 'ip-tech',
    title: 'Propriedade Intelectual & Tecnologia',
    items: [
      { id: 'source-code', label: 'Código-fonte em repositório controlado', status: 'done', note: 'GitHub private, CI/CD' },
      { id: 'architecture-doc', label: 'Documentação de arquitetura', status: 'done', note: '60 módulos documentados' },
      { id: 'ai-agents', label: 'AI Agents (35+) documentados', status: 'done' },
      { id: 'db-schema', label: 'Schema DB maduro (250+ migrations)', status: 'done' },
      { id: 'cv-models', label: 'Modelos de CV (TrackVision + SwimVision)', status: 'partial', note: 'Funcionais, falta registro INPI' },
      { id: 'trademark', label: 'Marca VUKZ registrada (INPI)', status: 'pending' },
      { id: 'patents', label: 'Patentes (pipeline AI + CV)', status: 'pending', note: 'Avaliar viabilidade' },
      { id: 'open-source', label: 'Auditoria de licenças open-source', status: 'partial' },
    ],
  },
  {
    id: 'data-privacy',
    title: 'Dados, Privacidade & LGPD',
    items: [
      { id: 'lgpd-compliance', label: 'Política de Privacidade publicada', status: 'done' },
      { id: 'data-governance', label: 'Microsoft Purview configurado', status: 'done' },
      { id: 'rls', label: 'Row-Level Security (multi-tenant)', status: 'done' },
      { id: 'consent-flow', label: 'Fluxo de consentimento (menores)', status: 'done' },
      { id: 'data-classification', label: 'Classificação de dados (PII)', status: 'done' },
      { id: 'dpo', label: 'DPO nomeado', status: 'pending', note: 'Founder acumula função' },
      { id: 'breach-process', label: 'Processo de notificação de breach', status: 'partial' },
      { id: 'data-retention', label: 'Política de retenção de dados', status: 'partial' },
    ],
  },
  {
    id: 'security',
    title: 'Segurança & Infraestrutura',
    items: [
      { id: 'azure-security', label: 'Azure security baseline', status: 'done' },
      { id: 'key-vault', label: 'Segredos em Key Vault', status: 'done' },
      { id: 'ci-cd', label: 'CI/CD com GitHub Actions', status: 'done' },
      { id: 'encryption', label: 'Dados sensíveis encriptados (CPF)', status: 'done' },
      { id: 'auth', label: 'Autenticação JWT + Entra ID ready', status: 'done' },
      { id: 'pentest', label: 'Pentest / security audit', status: 'pending' },
      { id: 'backup', label: 'Backup automatizado (Azure SQL)', status: 'done' },
      { id: 'disaster-recovery', label: 'Plano de DR documentado', status: 'partial' },
    ],
  },
  {
    id: 'financial',
    title: 'Financeiro & Fiscal',
    items: [
      { id: 'accounting', label: 'Contabilidade em dia', status: 'done' },
      { id: 'tax-compliance', label: 'Impostos em dia (Simples Nacional)', status: 'done' },
      { id: 'financial-model', label: 'Modelo financeiro (5 anos)', status: 'done', note: '9 cenários projetados' },
      { id: 'bank-accounts', label: 'Contas bancárias PJ separadas', status: 'done' },
      { id: 'revenue-evidence', label: 'Evidência de receita (pilotos)', status: 'in_progress' },
      { id: 'cap-table', label: 'Cap table definido', status: 'done' },
      { id: 'use-of-funds', label: 'Uso de recursos detalhado', status: 'done' },
    ],
  },
  {
    id: 'product-market',
    title: 'Produto & Mercado',
    items: [
      { id: 'product-live', label: 'Produto em produção', status: 'done' },
      { id: 'users', label: 'Usuários ativos (mesmo que pilotos)', status: 'in_progress' },
      { id: 'nps', label: 'NPS / feedback de clientes', status: 'pending' },
      { id: 'tam-sam-som', label: 'TAM/SAM/SOM definidos', status: 'done' },
      { id: 'competitors', label: 'Análise competitiva', status: 'done' },
      { id: 'roadmap', label: 'Roadmap de produto (2 anos)', status: 'done' },
      { id: 'partnerships', label: 'Parcerias estratégicas', status: 'partial', note: 'Microsoft confirmada, federações em negociação' },
    ],
  },
];

// ─── Helpers ────────────────────────────────────────────────────────────────

export function getDueDiligenceStats() {
  const all = DUE_DILIGENCE_SECTIONS.flatMap(s => s.items);
  const total = all.length;
  const done = all.filter(i => i.status === 'done').length;
  const partial = all.filter(i => i.status === 'partial').length;
  const inProgress = all.filter(i => i.status === 'in_progress').length;
  const pending = all.filter(i => i.status === 'pending').length;

  return {
    total,
    done,
    partial,
    inProgress,
    pending,
    completionPct: Math.round(((done + partial * 0.5 + inProgress * 0.3) / total) * 100),
  };
}
